// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"bef_a bha_bk bha_bl bha_bo","SwipeLeftToClose--animating":"bef_b"};